<section class="founder-section py-5">
  <div class="container text-center">
    <!-- Title -->
    <h2 class="section-title mb-3">A Message From Our Founders</h2>
    <h5 class="section-subtitle mb-4">
      Our Pure Mission: Nurturing Tomorrow's Leaders with Empathy and Vision
    </h5>

    <!-- Paragraph -->
    <p class="section-desc mb-4">
      Hear directly from the passionate minds behind Innovative Vision. Our founders share their
      personal inspiration & unwavering commitment to fostering holistic growth in every child.
      Discover the empathy that drives our mission to unlock potential, develop vital right-brain
      skills & cultivate a joyful, disciplined lifestyle for future generation.
    </p>

    <!-- Video -->
    <div class="video-wrapper mx-auto">
      <div class="embed-responsive embed-responsive-16by9">
        <video controls class="embed-responsive-item rounded shadow">
          <source src="assets/videos/founder-message.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  </div>
</section>
